<div
  class="card-form-group-container"
  [formGroup]="form">

  <mat-form-field>
    <mat-label>Data compilazione (CMPD)</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="CMPD" required>
    <mat-hint>DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <app-input-vocabulary-autocomplete
    formControlName="CMPN"
    [vocabularyName]="'V_CMPN'"
    [placeholder]="'Nome compilatore (CMPN)'">
  </app-input-vocabulary-autocomplete>
</div>
